import React from "react";
import { Form } from "../Components/Form";

const Registration = () => {
  return (
    <div>
      <Form />
    </div>
  );
};

export default Registration;
